import type { Query } from 'firebase/firestore'
import { documentId, query, where } from 'firebase/firestore'
import type { AproData } from '~/models'
import { MapService } from './serviceLive'

export class AproDataService extends MapService<AproData> {
  BATCH_SIZE = 30

  constructor() {
    super('AppUsers')
  }

  public listenForId(userId: string): void {
    this.collection = this.collectionConstructor(
      'AppUsers',
      userId,
      'ExternalUserData',
    )

    const listenQuery = query(
      this.collection,
      where(documentId(), '==', 'AproData'),
    )
    this.listen(listenQuery)
  }

  // The result is not queryable because the key is the document ID which is `AproData` and not unique per user
  public listenForIds(userIds: string[]): void {
    const queries: Query[] = []

    for (const userId of userIds) {
      const listenQuery = query(
        this.collectionConstructor('AppUsers', userId, 'ExternalUserData'),
        where(documentId(), '==', 'AproData'),
      )
      queries.push(listenQuery)
    }

    this.listenGroup(queries)
  }
}
